import { render, staticRenderFns } from "./MaterialBidList.vue?vue&type=template&id=611b0cb4&scoped=true&lang=pug&"
import script from "./MaterialBidList.vue?vue&type=script&lang=js&"
export * from "./MaterialBidList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBidList.vue?vue&type=style&index=0&id=611b0cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b0cb4",
  null
  
)

export default component.exports